exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "section[data-v-37673f57]{padding:20px 0}", "", {"version":3,"sources":["/home/www/deploy/school/src/views/warehouse/inventory/index.vue"],"names":[],"mappings":"AACA,yBACE,cAAgB,CACjB","file":"index.vue","sourcesContent":["\nsection[data-v-37673f57] {\n  padding: 20px 0;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-37673f57","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/warehouse/inventory/index.vue
// module id = 60Vl
// module chunks = 67